module.exports = __webpack_public_path__ + "static/media/orSaperator.d86634ef.svg";